import React from 'react';
import './blogs.module.css'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-regular-svg-icons';

const BlogChunk = ({id,title,urlTitle,description,date,timeToRead,comments,image}) => {

    const cleanDesc = (str) => {
        return str.replace(/<\/?[^>]+(>|$)/g, '');
    }

    const isMobile = window.innerWidth < 768;

    
    const ChunkLayout = () => {
        if (isMobile){
            return (
                <a href={`blogs/${urlTitle}`} className='blogChunkLink'>
                    <div className='singleBlogChunk'>
                        <img className="blogImage" src={image}/>
                        <div>
                            <div className='blogChunkTitle'>
                                {title}
                            </div>
                            <div className="blogChunkDescription">
                                {cleanDesc(description)}
                            </div>
                            <div className='blogChunkFooter'>
                                {date} · {timeToRead} read · <FontAwesomeIcon icon={faComment}/> {comments}
                            </div>
                        </div>
                    </div>
                </a>
            )
        }
        else {
            return (
                <a href={`blogs/${urlTitle}`} className='blogChunkLink'>
                    <div className='singleBlogChunk'>
                        <div>
                            <div className='blogChunkTitle'>
                                {title}
                            </div>
                            <div className="blogChunkDescription">
                                {cleanDesc(description)}
                            </div>
                            <div className='blogChunkFooter'>
                                {date} · {timeToRead} read · <FontAwesomeIcon icon={faComment}/> {comments}
                            </div>
                        </div>
                        <img className="blogImage" src={image}/>
                    </div>
                </a>
            )
        }
     
    }
    return (<ChunkLayout/>)

}

export default BlogChunk;


// WEBPACK FOOTER //
// ./src/components/Blogs/BlogChunk.js